/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageCard/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Loading from './Loading/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageCard({
  children,
  viewPath = "/DesignSystem/ImageCard",
  innerRef,
  zIndex,
  isHovering,
  zIndexHovering,
  onImageAnalyze
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Content'
let imageCardIsSavingValueData = fromData.useDataFormat({ viewPath,
context: 'image_card',
path: 'is_saving',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: imageCardIsSavingValueData,
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="ImageCard.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--bc-1-1kgDd2': isHovering ? dtColorsNeutral300 : "transparent",'--s-2-1kgDd2': isHovering ? 1.25 : 1,'--zi-3-1kgDd2': isHovering ? zIndexHovering : zIndex}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 onImageAnalyze={onImageAnalyze}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}